import React from 'react';
import { router } from '@inertiajs/react';
import { Button } from '../../components/ui/button';
import { UserForm } from './Form';
import { useTrans } from '../../hooks/useTrans';

function ActionPanel({ user, canBeManaged, isFederated }) {
    const translate = useTrans();

    if (!canBeManaged || isFederated) {
        return null;
    }

    function handlePasswordReset(e) {
        e.preventDefault();
        router.post('/send-reset-password-mail', {
            email: user.email,
            locale: user.language_name,
        });
    }

    function handleInvite(e) {
        e.preventDefault();
        router.post(`/gebruikers/${user.id}/uitnodigen`);
    }

    function handleUnlinkAuthenticator(e) {
        e.preventDefault();
        router.post(`/gebruikers/${user.id}/authenticator-app/ontkoppelen`);
    }

    return (
        <div className="bg-white rounded-[3px] border border-[#bbb] self-start">
            <div className="p-[30px]">
                {user.is_active ? (
                    <>
                        <h3 className="text-2xl font-bold text-[#003545] mb-2">
                            {translate('Stuur wachtwoord reset e-mail')}
                        </h3>
                        <p className="text-sm text-[#003545] mb-4">
                            {translate('Er wordt een e-mail verstuurd naar deze gebruiker met daarin een link om een nieuw wachtwoord in te stellen.')}
                        </p>
                        <form onSubmit={handlePasswordReset}>
                            <Button variant="primary" type="submit">
                                {translate('Verstuur')}
                            </Button>
                        </form>

                        {user.authenticator_configured_at && (
                            <>
                                <hr className="border-[#bbb] my-7" />
                                <h3 className="text-2xl font-bold text-[#003545] mb-2">
                                    {translate('Authenticator-app ontkoppelen')}
                                </h3>
                                <p className="text-sm text-[#003545] mb-4">
                                    {translate('Ontkoppel de authenticator-app van deze gebruiker.')}
                                </p>
                                <form onSubmit={handleUnlinkAuthenticator}>
                                    <button type="submit" className="inline-flex items-center gap-1.5 border border-[#e0e0e0] rounded-[4px] px-3 py-1.5 text-[13px] text-[#333] bg-transparent cursor-pointer transition-all hover:bg-[#f5f5f5]">
                                        <svg width="16" height="16" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 3H10M9 3V10C9 10.5 8.5 11 8 11H3C2.5 11 2 10.5 2 10V3M3.5 3V2C3.5 1.5 4 1 4.5 1H6.5C7 1 7.5 1.5 7.5 2V3M4.5 5.5V8.5M6.5 5.5V8.5" stroke="#DC3939" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        <span>{translate('Koppeling verwijderen')}</span>
                                    </button>
                                </form>
                            </>
                        )}
                    </>
                ) : (
                    <>
                        <h3 className="text-2xl font-bold text-[#003545] mb-2">
                            {translate('Stuur uitnodigingsmail')}
                        </h3>
                        <p className="text-sm text-[#003545] mb-4">
                            {translate('Er wordt een e-mail verstuurd naar deze gebruiker met daarin een link om een wachtwoord in te stellen.')}
                        </p>
                        <form onSubmit={handleInvite}>
                            <Button variant="primary" type="submit">
                                {translate('Verstuur')}
                            </Button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}

export default function UsersEdit({ user, roles, debtors, languages, emailDomain, canBeManaged, isFederated, infoMessage }) {
    return (
        <div className="max-w-[1200px] mx-auto px-4">
            {infoMessage && (
                <div className="bg-white border-l-[3px] border-l-[#003545] p-3 mb-[30px]">
                    <h5 className="text-lg font-bold text-[#003545]">{infoMessage}</h5>
                </div>
            )}
            {user && (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <UserForm
                        user={user}
                        roles={roles}
                        debtors={debtors}
                        languages={languages}
                        emailDomain={emailDomain}
                        canBeManaged={canBeManaged}
                        isFederated={isFederated}
                    />
                    <ActionPanel
                        user={user}
                        canBeManaged={canBeManaged}
                        isFederated={isFederated}
                    />
                </div>
            )}
        </div>
    );
}
